import { Injectable } from '@angular/core';
import { ISearchCriteria } from '../interfaces/search-criteria';
import { ISearchCriteriaFilter } from '../interfaces/search-criteria-filter';
import { EditService } from './edit.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class SearchCriteriaService extends EditService<ISearchCriteria, ISearchCriteriaFilter> {
  url = '/api/searchcriteria';
  entityTitle = 'Search';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  //useUpdateResponseHandler == false - to avoid the popup message
  create(search: ISearchCriteria, showMessage: boolean = true): Promise<any> {
    let successMsg = 'Search added.';

    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    return this.handleRequest(
      this.http.post(this.url + '/save', search, { headers: headers }),
      showMessage
        ? this.handlersFactory.getForCreate(this.entityTitle)
        : this.handlersFactory.getDefault(),
      successMsg,
    );
  }

  public update(id: number | string, item: ISearchCriteria): Promise<any> {
    let successMsg = 'Search edited.';
    return this.handleRequest(
      this.http.put(`${this.url}/${id}`, item),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    ).then(this.extractData);
  }

  getPage(filterCommand: ISearchCriteriaFilter): Promise<any> {
    let params = this.constructHttpParams(filterCommand);
    return this.handleRequest(
      this.http.get(this.url + '/getpage', { params: params }),
      this.handlersFactory.getForReadByFilter(),
    );
  }

  public getInboxJobs(criteria: ISearchCriteria): Promise<any> {
    return this.http
      .post(`${this.url}/adhoc`, criteria)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public extractData(res) {
    return res;
  }

  public handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }

  getAccessDetails(criteriaId: number): Promise<any> {
    return this.handleRequest<any>(
      this.http.get<any>(this.url + '/accessDetails/' + criteriaId),
      this.handlersFactory.getForReadById(this.entityTitle),
    );
  }
}
